import React, { useEffect, useState } from "react";

//third-party imports
import { IoClose } from "react-icons/io5";
import { HiSpeakerphone } from "react-icons/hi";

function AmazonListingAnnouncement({ show, onCloseModalLogin, }) {
    useEffect(() => {
        if (show) {
            document.body.style.overflow = "hidden";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [show]);

    if (!show) return null;
    return (
        <div className="wrapper">
            <div className="blurimg"></div>

            <div className="center">
                <div className="offer">
                    <div className="layerimg"></div>
                    <div className="layer"></div>

                    <div className="text">
                        <span className="topline">Now Published on Amazon Kindle</span>
                        <button
                            className="close-icon"
                            type="button"
                            aria-label="Close"
                            onClick={onCloseModalLogin}
                        >
                            <IoClose size={20} />
                        </button>

                        <h4>Our E-Book Salesforce Admin Mastery</h4>
                        <p>
                            A structured, beginner-friendly roadmap designed for freshers and
                            career switchers, now available on Kindle for those who prefer
                            learning in a well-organized digital format.
                        </p>
                        <a
                            href="https://amzn.in/d/02e3zJFH"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <button class="edu-btn subscribe btn-medium">Download Now</button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AmazonListingAnnouncement;
